import { IAM_CONTRACT, TWU_CONTRACT } from "../constants";
import { getTimeZoneFromSwaStation } from "../timeZoneService";
import {
  CALLOUT_OT_ASSIGNMENT_OPS_CARGO_PREFERENCES_LIST,
  CALLOUT_OT_ASSIGNMENT_PREFERENCES_LIST,
  OPS_CARGO_AGENTS_WORKGROUP_LIST,
} from "./constants";

export function getCalloutOTAssignmentPreferenceList(workgroup) {
  return OPS_CARGO_AGENTS_WORKGROUP_LIST.includes(workgroup)
    ? CALLOUT_OT_ASSIGNMENT_OPS_CARGO_PREFERENCES_LIST
    : CALLOUT_OT_ASSIGNMENT_PREFERENCES_LIST;
}

export function buildVoluntaryOTSignupPayload(employeeData, unionContract, signupData) {
  return {
    date: signupData.date.setZone(getTimeZoneFromSwaStation(signupData.station), { keepLocalTime: true }).toISO(),
    // Employee Info
    eid: employeeData.eid,
    firstName: employeeData.firstName,
    lastName: employeeData.lastName,
    station: signupData.station,
    jobCode: employeeData.jobCode,
    workgroup: signupData.workgroup,
    unionContract: unionContract,
    phoneNumber: signupData.phoneNumber,

    // OT Data - Common
    willAccept: signupData.willAccept,
    willWave45Min: signupData.waive45Min,
    isOff: signupData.isShiftOff,
    shifts: !signupData.isShiftOff
      ? signupData.shifts.map((segment) => ({
          start: formatShift(signupData.date, segment.shiftStartHr, segment.shiftStartMin, signupData.station),
          end: formatShift(signupData.date, segment.shiftEndHr, segment.shiftEndMin, signupData.station),
        }))
      : [],

    // IAM Specific
    ...(unionContract === IAM_CONTRACT ? buildIAMPayload(signupData) : {}),
    // TWU Specific
    ...(unionContract === TWU_CONTRACT ? buildTWUPayload(signupData) : {}),
  };
}

function buildIAMPayload(signupData) {
  return {
    daysOff: Object.keys(signupData.offDaysChecked)
      .filter((day) => signupData.offDaysChecked[day] === true)
      .map((day) => day),
    continuousWithType: signupData.continuousWith ? signupData.continuousWith : null,
    continuousWithTouching: signupData.continuousWith ? signupData.continuousWithTouching : null,
    calloutOTRank: signupData.calloutHours.reduce((acc, hour, index) => {
      acc[index + 1] = hour.preference ? hour.preference : null;
      return acc;
    }, {}),
    calloutAmPmPreferenceRank: signupData.calloutTimeOfDayPreferences.reduce((acc, time, index) => {
      acc[index + 1] = {
        preference: time.preference ? time.preference : null,
        touching: time.touchingShift,
      };
      return acc;
    }, {}),
  };
}

function buildTWUPayload(signupData) {
  return {
    calloutOTStatus: signupData.otStatus,
    continuousWithType: signupData.continuousWith,
    calloutOTRank: signupData.calloutAssignments.reduce((acc, assignment, index) => {
      acc[index + 1] = assignment.preference ? assignment.preference : null;
      return acc;
    }, {}),
  };
}

function formatShift(date, shiftHr, shiftMin, station) {
  return date
    .set({ hour: shiftHr, minute: shiftMin, second: 0, millisecond: 0 })
    .setZone(getTimeZoneFromSwaStation(station), { keepLocalTime: true })
    .toFormat("HH:mm");
}
